import React from "react";
import { fromJS, type List } from "immutable";
import { connect } from "react-redux";
import { Field } from "redux-form/immutable";
import { injectIntl, type WrappedComponentProps } from "react-intl";
import styled from "styled-components";

import { selectBox } from "../../select-box";
import messages from "../messages";
import type { ConditionFilterProps } from "../utils";

const Filter = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  @media only screen and (max-width: 1650px) {
    flex-direction: column;
    align-items: stretch;
  }
  @media only screen and (max-width: 550px) {
    margin-left: 0px;
  }
`;

interface TimeOfDayOwnProps extends ConditionFilterProps {
  selectedShop?: string;
}

interface TimeOfDayStateProps {
  availabilities?: List<unknown>;
}

type TimeOfDayProps = TimeOfDayOwnProps &
  TimeOfDayStateProps &
  WrappedComponentProps;

interface TimeOfDayState {
  editAvailabilityVisible: boolean;
  selectedId: string;
}

class TimeOfDay extends React.PureComponent<TimeOfDayProps, TimeOfDayState> {
  static defaultProps = {
    availabilities: fromJS([])
  };

  constructor(props: TimeOfDayProps) {
    super(props);

    this.state = {
      editAvailabilityVisible: false,
      selectedId: ""
    };
  }

  toggleAvailability(): void {
    this.setState({
      editAvailabilityVisible: !this.state.editAvailabilityVisible
    });
  }

  render(): React.ReactNode {
    return (
      <Filter>
        <Field
          name={`${this.props.member}.filter.operator`}
          component={selectBox}
          customProps={{
            options:
              [
                {
                  value: "within",
                  label: this.props.intl.formatMessage(messages.within)
                },
                {
                  value: "outsideOf",
                  label: this.props.intl.formatMessage(messages.outsideOf)
                }
              ],
            margin: "0 0 0 10px",
            minWidth: "120px"
          }}
        />
      </Filter>
    );
  }
}

interface LegacyTimeOfDayState {
  getIn(path: readonly (string | undefined)[]): List<unknown> | undefined;
}

const mapStateToProps = (
  state: LegacyTimeOfDayState,
  ownProps: TimeOfDayOwnProps & WrappedComponentProps
): TimeOfDayStateProps => ({
  availabilities: state.getIn([
    "customerBackendDashboard",
    "shops",
    ownProps.selectedShop,
    "availability",
    "data"
  ])
});

const ConnectedTimeOfDay = connect<
  TimeOfDayStateProps,
  Record<string, never>,
  TimeOfDayOwnProps & WrappedComponentProps,
  LegacyTimeOfDayState
>(mapStateToProps)(TimeOfDay);

export default injectIntl(ConnectedTimeOfDay);
